import {
  BlocklistItem,
  BlocklistEntryFormData,
  CreateBlocklistItemRequestData,
  UpdateBlocklistItemRequestData,
} from '../types';

export function buildFormData(data?: BlocklistItem, initialWord?: string): BlocklistEntryFormData {
  return {
    id: data?.id || '',
    word: data?.word || initialWord || '',
  };
}

export function buildRequestData(
  data: BlocklistEntryFormData,
): CreateBlocklistItemRequestData | UpdateBlocklistItemRequestData {
  return {
    word: data.word,
  };
}
